
export default {
  mounted() {
  },
};
